import styled from 'styled-components'
import {
	orange,
	gold,
	danger,
	dangerTint,
	black,
	textMuted,
	mutedGrey,
	white,
	surface2,
	border2,
} from '@/theme/colors'
import { radii, media, motion } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { dashedSlot } from '@/theme/recipes'
import { Button } from '@components/Button'
import { Input, Textarea, FieldLabel } from '@components/Field'

/** The shared form kit (Field + Button primitives) — one copy for every modal. */
export { Button, ButtonGroup, FormGroup, FormInput, FormLabel } from '@pages/Itinerary/AddEventModal/FormComponents.styles'

export const CompactFormLabel = styled(FieldLabel)`
	display: block;
	font-size: ${fontSizes.micro};
	margin-bottom: 4px;
`

export const LocationSecondaryText = styled.div`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
    margin-top: 8px;
    padding-left: 4px;
`

export const FormTextArea = styled(Textarea)`
	min-height: 100px;
`

export const FormDescription = styled.p`
    font-size: ${fontSizes.micro};
    color: ${mutedGrey};
    margin: -4px 0 8px;
`

export const DateInputRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${media.phone} {
        grid-template-columns: 1fr;
    }
`

export const DateInputGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`

export const GuestsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
`

export const GuestRow = styled.div<{ $isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    border-radius: ${radii.small};
    cursor: pointer;
    transition: background ${motion.fast};
    background: ${({ $isSelected }) => ($isSelected ? `${gold}1f` : 'transparent')};

    &:hover {
        background: ${({ $isSelected }) => ($isSelected ? `${gold}1f` : surface2)};
    }
`

export const GuestCheckbox = styled.div<{ $checked: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: ${radii.tiny};
    border: 2px solid ${({ $checked }) => ($checked ? orange : border2)};
    background: ${({ $checked }) => ($checked ? orange : white)};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all ${motion.fast};

    &::after {
        content: '${({ $checked }) => ($checked ? '\\2713' : '')}';
        color: ${white};
        font-size: ${fontSizes.micro};
        font-weight: 700;
    }
`

export const GuestName = styled.span`
    font-size: ${fontSizes.small};
    font-weight: 500;
    color: ${black};
    flex: 1;
`


export const GuestSummary = styled.div`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
    margin-top: 8px;
    padding: 8px 12px;
    background: ${surface2};
    border-radius: ${radii.small};
`

export const GuestError = styled.span`
    color: ${danger};
    font-weight: 500;
`

export const LinksSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const LinkRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const LinkInput = styled(Input)`
	flex: 1;
`

export const RemoveLinkButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })`
	padding: 0 10px;
	color: ${danger};
	border-color: ${danger}40;

	&:hover:not(:disabled) {
		background: ${dangerTint};
		color: ${danger};
		border-color: ${danger};
	}
`

export const AddLinkButton = styled.button`
	${dashedSlot}
	color: ${gold};
`

